"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonPlaceholder = void 0;
var AddonPlaceholder_1 = require("./AddonPlaceholder");
Object.defineProperty(exports, "AddonPlaceholder", { enumerable: true, get: function () { return AddonPlaceholder_1.AddonPlaceholder; } });
